import React, { useState, useEffect } from "react";
import { AppContext } from "../../../AppContext";

function PreviewPopup({
  imagePreview,
  isOpenModal,
  handleCloseFnLnModal,
  floatingTextSettings, // raw API format [{type, keyvalue}, ...]
  pageWidthValue,
  pageHeightValue,
  pageWidthLeftValue,
  PreviewText,
  selectedType
}) {
  const [identifyLeakerText, setIdentifyLeakerText] = useState("");

  function mapDocSettings(settings, staticEmail, documentId) {
    const result = {};
    settings.forEach(({ type, keyvalue }) => {
      switch (type) {
        case "FloatingText":
          result.floatingText =
            keyvalue === "0"
              ? staticEmail.toLowerCase()
              : keyvalue === "1"
                ? documentId
                : keyvalue === "2"
                  ? staticEmail.toLowerCase() + documentId
                  : "";
          result.cipherRext = keyvalue === "2" ? "Both" : "";
          break;
        case "SuffixPrefixFloatingText": {
          const parts = keyvalue?.split("-") ?? [];
          const suffixPrefixText = parts.length > 0 ? parts[0] : "";
          const suffixPrefix =
            parts.length > 1
              ? parts[1] === "1"
                ? "Prefix"
                : "Suffix"
              : "";

          result.suffixPrefixFloatingText = suffixPrefixText;
          result.suffixPrefixFloating = suffixPrefix;
          break;
        }
        case "Opacity":
          result.floatingOpacity =
            keyvalue === "0"
              ? "0.10"
              : keyvalue === "1"
                ? "0.20"
                : keyvalue === "2"
                  ? "0.30"
                  : keyvalue === "3"
                    ? "0.40"
                    : keyvalue === "4"
                      ? "0.50"
                      : keyvalue === "5"
                        ? "0.60"
                        : keyvalue === "6"
                          ? "0.70"
                          : keyvalue === "7"
                            ? "0.80"
                            : keyvalue === "8"
                              ? "0.90"
                              : "0.50";
          break;
        case "Navigation":
          result.navigation =
            keyvalue === "0" ? "TopRighttoBottomLeft" : "TopLefttoBottomRight";
          break;
        case "FontColor":
          result.fontColor =
            keyvalue === "0" ? "Red" : keyvalue === "1" ? "Green" : "Blue";
          break;
        case "FontSize":
          result.fontSize =
            keyvalue === "0"
              ? "Small"
              : keyvalue === "1"
                ? "Medium"
                : "Large";
          break;
        case "Speed":
          result.speed =
            keyvalue === "0"
              ? "0.5x"
              : keyvalue === "1"
                ? "1x"
                : keyvalue === "2"
                  ? "2x"
                  : "1x";
          break;
        default:
          break;
      }
    });
    return result;
  }

  // 🔹 Generate floating text HTML
  function FloatingText(docSettings) {
    const fontSizeMap = { Small: "8px", Medium: "11px", Large: "14px" };
    const speedMap = { "0.5x": "20s", "1x": "10s", "2x": "5s" };

    const prefix =
      docSettings.suffixPrefixFloating === "Prefix"
        ? `<i>${docSettings.suffixPrefixFloatingText}</i> `
        : "";
    const suffix =
      docSettings.suffixPrefixFloating === "Suffix"
        ? ` <i>${docSettings.suffixPrefixFloatingText}</i>`
        : "";

    const baseText = `${prefix}${docSettings.floatingText}${suffix}`.trim();
    let repeatCount = 0;
    let repatedGridCount = 0;
    if (docSettings.fontSize === "Small") {
      repatedGridCount = baseText.length >= 32 ? 33 : 33;
      repeatCount = baseText.length >= 32 ? 19 : 30;
      if (docSettings.navigation !== 'TopLefttoBottomRight' && docSettings.cipherRext === "Both") {
        repatedGridCount = 33;
        repeatCount = 12;
      }
      //  if(docSettings.floatingText.length === 16 && docSettings.suffixPrefixFloatingText  === ''){
      //       repatedGridCount = 33;
      //       repeatCount = 20;
      //  }
      if (docSettings.suffixPrefixFloatingText !== '') {
        if (docSettings.floatingText.length === 24) {
          repatedGridCount = 33;
          repeatCount = 17;
        }
        else if (docSettings.floatingText.length === 16) {
          repatedGridCount = 33;
          repeatCount = 19;
        }
        else {
          repatedGridCount = baseText.length >= 32 ? 33 : 33;
          repeatCount = baseText.length >= 32 ? 17 : 19;
        }
      }

      if (docSettings.suffixPrefixFloatingText === '' && docSettings.navigation === 'TopLefttoBottomRight' && docSettings.cipherRext === "Both") {
        repatedGridCount = 33;
        repeatCount = 12;
      }
      if (docSettings.suffixPrefixFloatingText !== '' && docSettings.navigation === 'TopLefttoBottomRight' && docSettings.cipherRext === "Both") {
        repatedGridCount = 33;
        repeatCount = 9;
      }
    }
    if (docSettings.cipherRext === "Both" && baseText.length > 50 && docSettings.fontSize !== "Small" && docSettings.fontSize !== 'Medium') {
      repeatCount = 7;
      repatedGridCount = 42;
      if (docSettings.navigation === 'TopLefttoBottomRight') {
        repatedGridCount = 30;
        repeatCount = 9;
      }

    }
    else if (docSettings.navigation !== 'TopLefttoBottomRight' && docSettings.cipherRext === "Both" && baseText.toLocaleLowerCase().length > 50 && docSettings.fontSize === "Small") {
      repeatCount = 9;
      repatedGridCount = 48;
    }
    else if (docSettings.cipherRext === "Both" && baseText.length <= 31 && docSettings.fontSize === "Small") {
      if (docSettings.navigation === 'TopLefttoBottomRight') {
        repatedGridCount = 34;
        repeatCount = 27;
      }
    }
    else if (docSettings.fontSize === 'Medium') {
      repeatCount = baseText.length >= 32 ? 8 : 10;
      repatedGridCount = baseText.length >= 32 ? 30 : 32;
      if (docSettings.fontSize === 'Medium') {
        repatedGridCount = baseText.length >= 32 ? 30 : 30;
        repeatCount = baseText.length >= 32 ? 18 : 20;
        if (baseText.length <= 50) {
          repatedGridCount = baseText.length >= 32 ? 33 : 34;
          repeatCount = baseText.length >= 32 ? 10 : 15;
        }
        if (docSettings.navigation === "TopRighttoBottomLeft") {
          if (docSettings.floatingText.length === 24 && docSettings.suffixPrefixFloatingText !== '') {
            repatedGridCount = 33;
            repeatCount = 11;
          }
          if (docSettings.floatingText.length === 16 && docSettings.suffixPrefixFloatingText !== '') {
            repatedGridCount = 33;
            repeatCount = 14;
          }
          else {
            repatedGridCount = baseText.length >= 32 ? 33 : 33;
            repeatCount = baseText.length >= 32 ? 13 : 15;
          }
        }
        if (docSettings.navigation === 'TopLefttoBottomRight') {
          if (docSettings.floatingText.length === 24 && docSettings.suffixPrefixFloatingText !== '') {
            repatedGridCount = 33;
            repeatCount = 11;
          } else {
            repatedGridCount = baseText.length >= 32 ? 33 : 33;
            repeatCount = baseText.length >= 32 ? 13 : 15;
          }
        }
        if (docSettings.cipherRext === "Both") {
          repatedGridCount = 33;
          repeatCount = 7;
        }
        if (docSettings.suffixPrefixFloatingText === '') {
          repatedGridCount = baseText.length >= 32 ? 33 : 34;
          repeatCount = baseText.length >= 32 ? 14 : 22;
        }
        if (docSettings.suffixPrefixFloatingText === '' && docSettings.cipherRext === "Both") {
          repatedGridCount = 36;
          repeatCount = 9;
        }
      }

    }
    if (docSettings.fontSize === "Large") {
      if (docSettings.navigation === 'TopLefttoBottomRight') {
        repatedGridCount = baseText.length >= 32 ? 30 : 30;
        repeatCount = baseText.length >= 32 ? 10 : 17;
      } else {
        repatedGridCount = baseText.length >= 32 ? 33 : 34;
        repeatCount = baseText.length >= 32 ? 11 : 15;
      }
      if (docSettings.cipherRext === "Both") {
        repatedGridCount = 33;
        repeatCount = 5;
      }
      if (docSettings.floatingText.length === 24 && docSettings.suffixPrefixFloatingText !== '') {
        repatedGridCount = 33;
        repeatCount = 10;
      }
      if (docSettings.cipherRext !== "Both" && docSettings.suffixPrefixFloatingText === '') {
        repatedGridCount = baseText.length >= 32 ? 32 : 34;
        repeatCount = baseText.length >= 32 ? 11 : 20;
      }
      if (docSettings.cipherRext !== "Both" && docSettings.navigation === 'TopLefttoBottomRight' && docSettings.suffixPrefixFloatingText !== '') {
        repatedGridCount = baseText.length >= 32 ? 32 : 34;
        repeatCount = baseText.length >= 32 ? 9 : 20;
      }
      if (docSettings.cipherRext === "Both" && docSettings.suffixPrefixFloatingText !== '') {
        repatedGridCount = 33;
        repeatCount = 6;
      }
      if (docSettings.cipherRext === "Both" && docSettings.suffixPrefixFloatingText === '') {
        repatedGridCount = 33;
        repeatCount = 9;
      }
      if (docSettings.cipherRext === "Both" && docSettings.suffixPrefixFloatingText === '' && docSettings.navigation === 'TopLefttoBottomRight') {
        repatedGridCount = 33;
        repeatCount = 8;
      }
      if (docSettings.floatingText.length === 16 && docSettings.navigation === "TopLefttoBottomRight" && docSettings.suffixPrefixFloatingText !== '') {
        repatedGridCount = 32;
        repeatCount = 10;
      }
    }
    let repeatedRow = "";
    for (let i = 0; i < repeatCount; i++) {
      repeatedRow += `&nbsp;&nbsp;&nbsp;&nbsp;${baseText}`;
    }
    let repeatedGrid = "";
    for (let j = 0; j < repatedGridCount; j++) {
      repeatedGrid += `<div style="height:60px">${repeatedRow}</div>`;
    }
    const watermarkStyle = `
       width: 2800px;
                  position: absolute;
                  animation: ${docSettings.navigation == "TopLefttoBottomRight" ? "floatAnimr" : "floatAnim"} ${speedMap[docSettings.speed] || "10s"} linear infinite alternate;
                  transform: rotateZ(${docSettings.navigation == "TopLefttoBottomRight" ? "-45deg" : "45deg"});
                  margin-left: -1200px;
                  margin-top: -400px;
                  font-size: ${fontSizeMap[docSettings.fontSize] || "14px"};
                  color: ${docSettings.fontColor.toLowerCase()};
                  opacity: ${docSettings.floatingOpacity};
                  pointer-events: none;
    `;

    return `<div class="watermark noselect" style="${watermarkStyle}">${repeatedGrid}</div>`;
  }

  useEffect(() => {
    if (floatingTextSettings && floatingTextSettings.length > 0) {
      const mapped = mapDocSettings(
        floatingTextSettings,
        "john@hotmail.com",
        "265093748524CAAD2636AADB"
      );
      const html = FloatingText(mapped);
      setIdentifyLeakerText(html);
    } else {
      setIdentifyLeakerText("");
    }
  }, [floatingTextSettings]);

  if (!isOpenModal) return null;

 return (
  <>
<div
  className="child-popupPreview"
  id="previewModal"
  style={{ width: "990px", height: "80vh" }}
>
  <div className="modal-dialog-centered" style={{ height: "100%" }}>
    <div className="modal-content" style={{ height: "100%" }}>
      <div className="modal-header">
        <h4 className="text-danger fw-bold" style={{ margin: "0px" }}>
          {PreviewText}
        </h4>
        <button
          type="button"
          className="btn btn-outline-danger Readerclose modalclose download mt-1"
          style={{
            position: "absolute",
            top: "10px",
            right: "10px",
            zIndex: 10,
          }}
          onClick={handleCloseFnLnModal}
        >
          <span className="material-icons font-20">highlight_off</span>
        </button>
      </div>

      {/* Scrollable Body */}
      <div
        className="modal-body"
        style={{
          flex: "1 1 auto",
          overflow: "auto",
          padding: "5px",
        }}
      >
        <div className="no-visual-search" style={{ width: "100%" }}>

          {(selectedType === "Floating Text Only"
            ? [AppContext.IDLekarsPreviewImageBase64URL]   
            : imagePreview || []
          ).map((url, idx) => (
            <div key={idx} style={{ position: "relative" }}>
              <img
                className="rm-transform1 rm-trans"
                src={`data:image/png;base64,${url}`}
                alt=""
                style={{
                  width: "930px",
                  height: "1315.5px",
                  display: "block",
                }}
              />

              {selectedType !== "Cipher Text Only" && (
                <div
                  className="watermarkParent"
                  style={{
                    position: "absolute",
                    top: "15px",
                    left: "20px",
                    width: "930px",
                    height: "1300px",
                    pointerEvents: "none",
                  }}
                >
                  <div
                    className="watermark noselect"
                    dangerouslySetInnerHTML={{
                      __html: identifyLeakerText,
                    }}
                  />
                </div>
              )}
            </div>
          ))}

        </div>
      </div>
    </div>
  </div>
</div>






  </>
);

}

export default PreviewPopup;
